import React, { useRef } from 'react'
import { Formik, Form } from 'formik'
import { useLocation, useNavigate } from 'react-router-dom'
import { Box, Typography, Icon } from '@mui/material'
import AdxFormModal from 'components/reusable/modal/AdxFormModal'
import Bugsnag from '@bugsnag/js'
import CloseWarning from './CloseWarning'
import InviteMultipleStaffForm from './InviteMultipleStaffForm'

import { useMutation } from 'react-query'
import { handleValidationErrors } from 'services/helper/handleValidationErrors'

// API
import { postInviteStaffImport } from 'services/api/modules/staff-management/staffManagementDashboard'

const InviteMultipleStaff = (state) => {
  const formikRef = useRef()

  const navigate = useNavigate()
  const location = useLocation()

  const handleCloseModal = (event, reason) => {
    if (reason && reason === 'backdropClick') {
      return
    }
    navigate(-1)
  }

  const mutation = useMutation(postInviteStaffImport, {
    onSuccess: (response) => {
      navigate(
        '/app/management-centre/staff-management/employee-file/invite-multiple-staff/import',
        {
          state: {
            backgroundLocation: location,
            staffData: response.data,
          },
        }
      )
    },
    onError: (error) => {
      if (error.status === 422) {
        if (error.data?.errors) {
          handleValidationErrors(error, formikRef)
        } else {
          let errors = {
            invite_staff_file: [error.data.message],
          }
          let newError = {
            data: {
              errors,
            },
          }
          handleValidationErrors(newError, formikRef)
        }
      } else {
        Bugsnag.notify(error.data)
        let errors = {
          invite_staff_file: [error.data.message],
        }
        let newError = {
          data: {
            errors,
          },
        }
        handleValidationErrors(newError, formikRef)
      }
    },
  })

  const handleUploadImport = async (values) => {
    let newData = values.invite_staff_file[0]
    let formData = new FormData()
    formData.append('invite_staff_file', newData)
    mutation.mutate(formData)
  }

  return (
    <AdxFormModal
      open={true}
      onClose={handleCloseModal}
      handleClose={handleCloseModal}
      disableEscapeKeyDown
      disableAutoFocus
      sx={{
        '&.MuiModal-root': { overflowY: 'auto' },
        paddingY: '20px',
      }}
      sxModal={{
        minWidth: { xs: 'none', sm: 'calc(100vw - 30px)', lg: '580px' },
        width: { xs: 'calc(100vw - 30px)', lg: 'calc(100vw - 1500px)' },
      }}
      title="Invite multiple staffs"
      subtitle={null}
    >
      <Formik
        enableReinitialize
        initialValues={{
          invite_staff_file: null,
        }}
        onSubmit={handleUploadImport}
        innerRef={formikRef}
      >
        {(formikProps) => (
          <>
            <Form>
              <InviteMultipleStaffForm formikProps={formikProps} />
            </Form>
          </>
        )}
      </Formik>
    </AdxFormModal>
  )
}

export default InviteMultipleStaff
